import { render } from "./JbButton.vue?vue&type=template&id=2e9d860d"
import script from "./JbButton.vue?vue&type=script&lang=js"
export * from "./JbButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__